import { colors, fonts, screen } from 'components/styles/variables';
import searchIcon from 'public/static/images/paid_landing/search-icon.svg';
import { useEffect, useState } from 'react';
import Geocode from 'types/Geocode';
import useEvents from 'lib/hooks/useEvents';
import viewEvent from 'lib/Tracking/Onboarding/ViewEvent';
import { SourcePages } from 'lib/EventSchema';
import { useGeolocationData } from 'lib/hooks/useGeoLocation';
import LocationInput, { getLocationLabel } from './LocationInput';

import { OnboardingComponentProps } from '../Modal';
import Button from '../Button';
import AutolistLogo from '../Logo';
import { useFilterContext } from '../../../contexts/OnboardingFilterContext';

const Location = ({ t, onNextStep }: OnboardingComponentProps): JSX.Element => {
  const geolocationData = useGeolocationData();

  let initialFilterLocation;
  if (geolocationData) {
    const { city, latitude, longitude, stateAbbreviation } = geolocationData;
    initialFilterLocation = { city, latitude, longitude, stateCode: stateAbbreviation };
  }

  const logger = useEvents();
  const { filterData, updateFilterData } = useFilterContext();
  const filterLocation = filterData.Location || initialFilterLocation;
  const locationLabel = getLocationLabel(t, filterLocation);
  const [showSelectedCity, setShowSelectedCity] = useState(!!locationLabel);

  const onLocationSelection = (location: Geocode): void => {
    const { latitude, longitude, city, stateAbbreviation } = location;
    updateFilterData({
      Location: {
        latitude,
        longitude,
        city,
        stateCode: stateAbbreviation,
      },
    });
    setShowSelectedCity(true);
  };

  useEffect(() => {
    logger.log(viewEvent({ sourcePage: SourcePages.OnboardingLocation }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="location-step-container">
        <AutolistLogo />
        <div className="header">{t('onboarding.locationScreen.header')}</div>
        {showSelectedCity ? (
          <div
            className="input-container"
            onClick={(): void => {
              setShowSelectedCity(false);
            }}
          >
            <div className="search-icon" />
            <input
              type="text"
              name="location"
              autoComplete="off"
              autoFocus={true}
              readOnly
              value={locationLabel}
            />
          </div>
        ) : (
          <div className="location-container">
            <LocationInput
              className="onboarding-location-container"
              onSelect={onLocationSelection}
            />
          </div>
        )}
        <Button onClick={onNextStep}>{t('onboarding.next')}</Button>
      </div>

      <style jsx>{`
        .location-step-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 295px;
        }
        .autolist-logo {
          margin-bottom: 16px;
        }
        .header {
          text-align: center;
          font-family: ${fonts.default};
          font-weight: 700;
          font-size: 22px;
          line-height: 32px;
          letter-spacing: 0.2px;
          margin-bottom: 25px;
        }
        .location-container {
          border: 1px solid ${colors.G2};
          border-radius: 8px;
          width: 298px;
          height: 340px;
          box-shadow: 0px 24px 38px 0px rgba(0, 0, 0, 0.2);
          margin-bottom: 35px;
        }

        .input-container {
          position: relative;
          padding: 0px 16px;
          border: 1px solid #d3d3d3;
          box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.08);
          border-radius: 8px;
          cursor: pointer;
          margin-bottom: 325px;
          width: 298px;
        }

        .search-icon {
          position: absolute;
          z-index: 1;
          height: 22px;
          width: 22px;
          top: 13px;
          left: 21px;
          background-image: url('${searchIcon}');
          background-size: cover;
        }

        input {
          cursor: pointer;
          background-color: white;
          border: none;
          height: 48px;
          width: 100%;
          font-size: 16px;
          line-height: 24px;
          font-weight: 400;
          letter-spacing: 0.2px;
          color: ${colors.BLACK};
          padding: 5px 5px 5px 42px;
          -webkit-appearance: none;
          border-radius: 8px;
          outline: none;
          font-family: ${fonts.default};
        }

        input ::placeholder {
          color: ${colors.G3};
          font-weight: 100;
        }
      `}</style>
      <style jsx global>{`
        .onboarding-location-container .scrolling-container {
          max-height: 272px;
        }

        @media (min-width: ${screen.smMin}) {
          .onboarding-location-container .scrolling-container {
            height: 100%;
            min-height: auto;
          }
        }

        .onboarding-location-container .search-icon {
          top: 17px !important;
        }

        .onboarding-location-container .input-container input {
          height: 40px;
          padding: 0px 5px 0px 42px;
        }
      `}</style>
    </>
  );
};

export default Location;
